module.exports = __webpack_public_path__ + "aa4e2fd21fac327267b6894d813237b1.webp";